import React from 'react';
import { Link } from 'react-router-dom';
import Footer from '../components/Footer';

function Success() {
  return (
    <div className="min-h-screen bg-gradient-to-br from-green-50 to-emerald-100 flex flex-col">
      <div className="flex-grow flex items-center justify-center p-4">
        <div className="max-w-md w-full bg-white rounded-lg shadow-xl p-8 text-center">
          <div className="mb-6">
            <div className="mx-auto w-16 h-16 bg-green-100 rounded-full flex items-center justify-center">
              <svg className="w-10 h-10 text-green-600" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M5 13l4 4L19 7" />
              </svg>
            </div>
          </div>

          <h1 className="text-3xl font-bold text-gray-900 mb-2">Payment Successful!</h1>
          <p className="text-gray-600 mb-6">
            Your subscription has been activated. You now have access to your upgraded plan.
          </p>

          <div className="space-y-3">
            <Link
              to="/dashboard"
              className="block w-full bg-indigo-600 text-white py-3 px-4 rounded-lg hover:bg-indigo-700 font-medium"
            >
              Go to Dashboard
            </Link>
            <Link
              to="/api-keys"
              className="block w-full bg-gray-100 text-gray-700 py-3 px-4 rounded-lg hover:bg-gray-200 font-medium"
            >
              View API Keys
            </Link>
          </div>

          <p className="mt-6 text-sm text-gray-500">
            You'll receive a confirmation email shortly.
          </p>
        </div>
      </div>
      <Footer />
    </div>
  );
}

export default Success;